import { Container, Row, Col, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import UniformImage from "../../../components/font-end/UniformSurvey/UniformImage";
import {
  UniformBenefitType,
  UniformLatestType,
  uniform_survey_schedulers,
} from "../../../model/datatype";
import {
  UniformBenefit,
  UniformLastest,
} from "../../../services/ApiUniformSurvey";
import Moment from "moment";
import moment from "moment-timezone";
import { useMsal } from "@azure/msal-react";

export const SuccessfullyUniformSurvey = (props: any) => {
  const { accounts } = useMsal();
  const [isLoading, setIsLoading] = useState(true); // ✅ state สำหรับ loading
  const [uniformAmont, setUniformAmont] = useState(0);
  const [uniformImage, setUniformImage] = useState("");
  const [uniformImage2, setUniformImage2] = useState("");
  const [uniformtype, setUniformtype] = useState<UniformBenefitType | null>(
    null
  );
  const [uniformLastest, setUniformLastest] =
    useState<UniformLatestType | null>(null);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const timezoneStr =
    Intl.DateTimeFormat().resolvedOptions().timeZone || "FallbackTimeZone";

  if (localStorage.getItem("Language") === "en") {
    Moment.locale("en-sg");
  } else {
    Moment.locale("th");
  }

  useEffect(() => {
    setIsLoading(true); // เริ่มโหลด
    // Use MSAL accounts instead of sessionStorage for user identity
    const userEmail = accounts.length > 0 ? accounts[0].username : null;
    if (!userEmail) {
      setIsLoading(false);
      return;
    }
    Promise.all([UniformBenefit(undefined, userEmail), UniformLastest()])
      .then(([benefitRes, lastestRes]) => {
        setUniformImage2(benefitRes.shirtType);
        setUniformtype(benefitRes);
        const total =
          benefitRes.shirtQty +
          benefitRes.pantsQty +
          benefitRes.slipperQty +
          benefitRes.tumblerQty +
          benefitRes.dressQty +
          benefitRes.braQty;
        setUniformAmont(total);

        setUniformImage(lastestRes.shirtType);
        setUniformLastest(lastestRes);
      })
      .catch((error) => {
        // Failed to load uniform data
      })
      .finally(() => {
        setIsLoading(false); // โหลดเสร็จ
      });
  }, [accounts]); // Add accounts as dependency

  const ComponentStyle = {
    marginBottom: "75px",
  };

  const arrGender: any = {
    Female: "หญิง",
    Male: "ผู้ชาย",
  };

  return (
    <>
      <Container className=" uniform-survey-info  mt-4 mb-2">
        <Row>
          <Col className="unifrom-success   fw-bold py-2 px-2">
            {t("uniform_survey.message_successfully")}
          </Col>
        </Row>
        <Row className="justify-content-md-center ">
          <Col className="py-2">
            <div className="uniform-title text-danger">
              {t(
                "uniform_survey.conform_your_uniform.messages_alert_contect_admin"
              )}
            </div>
          </Col>
        </Row>
      </Container>
      <div
        className="uniform-survey-info full-screen-box-item-home"
        style={ComponentStyle}
      >
        <Container className="">
          <Row className="justify-content-md-center">
            <Col xs={2} md={1} lg={1}>
              <div className="bg-cicle-title">
                <a href="/">
                  <img
                    src="../images/UniformSurvey.png"
                    alt="UniformSurvey"
                    width={40}
                    className="mt-1"
                  />
                </a>
              </div>
            </Col>
            <Col xs={4} md={5} lg={5} className="p-0">
              <div className="uniform-title">
                {t("uniform_survey.your_uniform.title")}
              </div>
            </Col>
            <Col xs={6} md={6} lg={6} className="text-end mt-1 ">
              {/* {(itemSchedulers?.statusStr ==="Active")?
                                (uniformLastest && uniformLastest !== null)?
                                    <>
                                        <Button className="btn-update-survey" onClick={() => handleEdit()}>{t('uniform_survey.your_uniform.update_survey')}</Button>
                                    </>
                                    :
                                    <>
                                    
                                    </>
                                :<></>
                            } */}
            </Col>
          </Row>
          <Row>
            <Col>
              <hr className="mt-2 pt-1 mb-1" />
            </Col>
          </Row>
          {uniformLastest ? (
            <>
              <Row>
                <Col xs={4} md={2} lg={2}>
                  <UniformImage
                    imagesName={uniformImage2}
                    size="xl"
                    customSize=""
                  />
                  {/* <img
                    src={uniformImage2}
                    alt="UniformSurvey"
                    className="m-2 mb-2 rounded w-100 border rounded item-shadow"
                  /> */}
                </Col>
                <Col xs={8} md={8} lg={8}>
                  <div className="title-tpye m-1 mt-3 mb-2">
                    {t("uniform_survey.your_uniform.uniform_type")}
                  </div>
                  {/* <div className="title-show-type m-1 mb-3">{(localStorage.getItem('Language') === 'en')?uniformtype?.shirtDescriptionEn:uniformtype?.shirtDescriptionTh}</div> */}
                  <div className="title-show-type m-1 mb-3">
                    {localStorage.getItem("Language") === "en"
                      ? uniformtype?.shirtDescriptionEn
                      : uniformtype?.shirtDescriptionTh}
                  </div>
                </Col>
                {/* <Col xs={3} md={3} lg={2}>
                            <div className="amount mt-3">{t('uniform_survey.your_uniform.amount')}</div>
                            <div className="number mt-2">{uniformAmont}</div>
                        </Col> */}
              </Row>

              {uniformLastest !== null ? (
                <>
                  <Row>
                    <Col>
                      <hr className="mt-1 pt-0 mb-0" />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={2} md={1} lg={1}>
                      <img
                        src="../images/list.png"
                        alt="UniformSurvey"
                        className="m-2 mb-0 rounded"
                      />
                    </Col>
                    <Col xs={10} md={11} lg={11}>
                      <div className="lastest-title mt-2">
                        {t("uniform_survey.latest_uniform_survey.title")}
                      </div>
                      <div className="lastest-date">
                        {t("uniform_survey.latest_uniform_survey.date")} :{" "}
                        {moment(uniformLastest?.surveyDateTime + "Z")
                          .tz(timezoneStr)
                          .format("DD MMM YYYY HH:mm:ss")}
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col>
                      <hr className="mt-2 pt-0 mb-0" />
                    </Col>
                  </Row>
                  {uniformLastest && uniformLastest?.shirtQty !== null ? (
                    <Row className="mb-1 align-items-center">
                      <Col xs={2} md={2} lg={2} className="text-center">
                        <UniformImage
                          imagesName={uniformImage}
                          size="sm"
                          customSize=""
                        />
                        {/* <img
                          src={uniformImage}
                          alt="UniformSurvey"
                          width={45}
                          className="m-2 rounded item-shadow border"
                        /> */}
                      </Col>
                      <Col xs={7} md={7} lg={8}>
                        <div className="list-title font-wiegth-bold">
                          {localStorage.getItem("Language") === "en"
                            ? uniformLastest?.shirtDescriptionEn
                            : uniformLastest?.shirtDescriptionTh}
                        </div>
                        <div className="list-size">
                          {/* {uniformLastest?.shirtSize !== 'Decline' ? (
                            'Size: ' +
                            uniformLastest?.shirtSize +
                            '(' +
                            uniformLastest?.shirtGender +
                            ')'
                          ) : (
                            <>
                              <span className="text-danger">
                                {t('uniform_survey.choose_uniform.no_receive')}
                              </span>
                            </>
                          )} */}
                          {uniformLastest?.shirtSize === "Decline" ? (
                            <>
                              <span className="text-danger">
                                {t("uniform_survey.choose_uniform.no_receive")}
                              </span>
                            </>
                          ) : (
                            <></>
                          )}
                          {uniformLastest?.shirtSize ===
                          "Bigger than normal size" ? (
                            <>
                              {t("uniform_survey.choose_uniform.big_size")}(
                              {localStorage.getItem("Language") === "en"
                                ? uniformLastest?.shirtGender
                                : arrGender[uniformLastest?.shirtGender]}
                              )
                            </>
                          ) : (
                            <></>
                          )}
                          {uniformLastest?.shirtSize !==
                            "Bigger than normal size" &&
                          uniformLastest?.shirtSize !== "Decline" ? (
                            <>
                              {t("uniform_survey.choose_uniform.size")}:{" "}
                              {uniformLastest?.shirtSize} (
                              {localStorage.getItem("Language") === "en"
                                ? uniformLastest?.shirtGender
                                : arrGender[uniformLastest?.shirtGender]}
                              )
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div>
                          {uniformLastest?.shirtSize ==
                          "Bigger than normal size" ? (
                            <p
                              className="text-danger"
                              style={{ fontSize: "10px" }}
                            >
                              {uniformLastest?.shirtSizeDescription}
                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                      </Col>
                      <Col xs={3} md={3} lg={2}>
                        <div className="number mt-4">
                          {uniformLastest?.shirtSize !== "Decline"
                            ? uniformLastest?.shirtQty
                            : 0}
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                  {uniformLastest && uniformLastest?.pantQty !== null ? (
                    <Row className="mb-1 align-items-center">
                      <Col xs={2} md={2} lg={2} className="text-center">
                        <img
                          src="../images/uniform/pants.png"
                          alt="UniformSurvey"
                          width={45}
                          className="m-2 rounded item-shadow border"
                        />
                      </Col>
                      <Col xs={7} md={7} lg={8}>
                        <div className="list-title font-wiegth-bold">
                          {localStorage.getItem("Language") === "en" ? (
                            <>{uniformtype?.pantsDescriptionEn}</>
                          ) : (
                            <>{uniformtype?.pantsDescriptionTh}</>
                          )}
                        </div>
                        <div className="list-size">
                          {/* {uniformLastest?.pantSize !== 'Decline' ? (
                            'Size: ' +
                            uniformLastest?.pantSize +
                            '(' +
                            uniformLastest?.pantGender +
                            ')'
                          ) : (
                            <>
                              <span className="text-danger">
                                {t('uniform_survey.choose_uniform.no_receive')}
                              </span>
                            </>
                          )} */}
                          {uniformLastest?.pantSize === "Decline" ? (
                            <>
                              <span className="text-danger">
                                {t("uniform_survey.choose_uniform.no_receive")}
                              </span>
                            </>
                          ) : (
                            <></>
                          )}
                          {uniformLastest?.pantSize ===
                          "Bigger than normal size" ? (
                            <>
                              {t("uniform_survey.choose_uniform.big_size")}(
                              {localStorage.getItem("Language") === "en"
                                ? uniformLastest?.pantGender
                                : arrGender[uniformLastest?.pantGender]}
                              )
                            </>
                          ) : (
                            <></>
                          )}
                          {uniformLastest?.pantSize !==
                            "Bigger than normal size" &&
                          uniformLastest?.pantSize !== "Decline" ? (
                            <>
                              {t("uniform_survey.choose_uniform.size")}:{" "}
                              {uniformLastest?.pantSize}{" "}
                              {t("uniform_survey.choose_uniform.UnitBar")} (
                              {localStorage.getItem("Language") === "en"
                                ? uniformLastest?.pantGender
                                : arrGender[uniformLastest?.pantGender]}
                              )
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div>
                          {uniformLastest?.pantSize ==
                          "Bigger than normal size" ? (
                            <p
                              className="text-danger"
                              style={{ fontSize: "10px" }}
                            >
                              {uniformLastest?.pantSizeDescription}
                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                      </Col>
                      <Col xs={3} md={3} lg={2}>
                        <div className="number mt-4">
                          {uniformLastest?.pantSize !== "Decline"
                            ? uniformLastest?.pantQty
                            : 0}
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                  {uniformLastest && uniformLastest?.dressQty !== null ? (
                    <Row className="mb-1 align-items-center">
                      <Col xs={2} md={2} lg={2} className="text-center">
                        <img
                          src="../images/uniform/dress.png"
                          alt="UniformSurvey"
                          width={45}
                          className="m-2 rounded item-shadow border"
                        />
                      </Col>
                      <Col xs={7} md={7} lg={8}>
                        <div className="list-title font-wiegth-bold">
                          {localStorage.getItem("Language") === "en"
                            ? uniformtype?.dressDescriptionEn
                            : uniformtype?.dressDescriptionTh}
                        </div>
                        <div className="list-size">
                          {/* {uniformLastest?.dressSize !== 'Decline' ? (
                            'Size: ' + uniformLastest?.dressSize
                          ) : (
                            <>
                              <span className="text-danger">
                                {t('uniform_survey.choose_uniform.no_receive')}
                              </span>
                            </>
                          )} */}
                          {uniformLastest?.dressSize === "Decline" ? (
                            <>
                              <span className="text-danger">
                                {t("uniform_survey.choose_uniform.no_receive")}
                              </span>
                            </>
                          ) : (
                            <></>
                          )}
                          {uniformLastest?.dressSize ===
                          "Bigger than normal size" ? (
                            <>{t("uniform_survey.choose_uniform.big_size")}</>
                          ) : (
                            <></>
                          )}
                          {uniformLastest?.dressSize !==
                            "Bigger than normal size" &&
                          uniformLastest?.dressSize !== "Decline" ? (
                            <>
                              {t("uniform_survey.choose_uniform.size")}:{" "}
                              {uniformLastest?.dressSize}{" "}
                              {t("uniform_survey.choose_uniform.UnitSlipper")}
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div>
                          {uniformLastest?.dressSize ==
                          "Bigger than normal size" ? (
                            <p
                              className="text-danger"
                              style={{ fontSize: "10px" }}
                            >
                              {uniformLastest?.dressSizeDescription}
                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                      </Col>
                      <Col xs={3} md={3} lg={2}>
                        <div className="number mt-4">
                          {uniformLastest?.dressSize !== "Decline"
                            ? uniformLastest?.dressQty
                            : 0}
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                  {uniformLastest && uniformLastest?.braQty !== null ? (
                    <Row className="mb-1 align-items-center">
                      <Col xs={2} md={2} lg={2} className="text-center">
                        <img
                          src="../images/uniform/bras.png"
                          alt="UniformSurvey"
                          width={45}
                          className="m-2 rounded item-shadow border"
                        />
                      </Col>
                      <Col xs={7} md={7} lg={8}>
                        <div className="list-title font-wiegth-bold">
                          {localStorage.getItem("Language") === "en"
                            ? uniformtype?.braDescriptionEn
                            : uniformtype?.braDescriptionTh}
                        </div>
                        <div className="list-size">
                          {uniformLastest?.braSize === "Decline" ? (
                            <>
                              <span className="text-danger">
                                {t("uniform_survey.choose_uniform.no_receive")}
                              </span>
                            </>
                          ) : (
                            <></>
                          )}
                          {uniformLastest?.braSize ===
                          "Bigger than normal size" ? (
                            <>{t("uniform_survey.choose_uniform.big_size")}</>
                          ) : (
                            <></>
                          )}
                          {uniformLastest?.braSize !==
                            "Bigger than normal size" &&
                          uniformLastest?.braSize !== "Decline" ? (
                            <>
                              {" "}
                              {t("uniform_survey.choose_uniform.size")}:{" "}
                              {uniformLastest?.braSize} (
                              {t("uniform_survey.choose_uniform.UnitSlipper")}/{" "}
                              {t("uniform_survey.choose_uniform.UnitBar")})
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div>
                          {uniformLastest?.braSize ==
                          "Bigger than normal size" ? (
                            <p
                              className="text-danger"
                              style={{ fontSize: "10px" }}
                            >
                              {uniformLastest?.braSizeDescription}
                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                      </Col>
                      <Col xs={3} md={3} lg={2}>
                        <div className="number mt-4">
                          {uniformLastest?.braSize !== "Decline"
                            ? uniformLastest?.braQty
                            : 0}
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                  {uniformLastest && uniformLastest?.slipperQty !== null ? (
                    <Row className="mb-1 align-items-center">
                      <Col xs={2} md={2} lg={2} className="text-center">
                        <img
                          src="../images/uniform/slippers.png"
                          alt="UniformSurvey"
                          width={45}
                          className="m-2 rounded item-shadow border"
                        />
                      </Col>
                      <Col xs={7} md={7} lg={8}>
                        <div className="list-title font-wiegth-bold">
                          {localStorage.getItem("Language") === "en"
                            ? uniformtype?.slipperDescriptionEn
                            : uniformtype?.slipperDescriptionTh}
                        </div>
                        <div className="list-size">
                          {/* {uniformLastest?.slipperSize !== 'Decline' ? (
                            'Size: ' + uniformLastest?.slipperSize
                          ) : (
                            <>
                              <span className="text-danger">
                                {t('uniform_survey.choose_uniform.no_receive')}
                              </span>
                            </>
                          )} */}
                          {uniformLastest?.slipperSize === "Decline" ? (
                            <>
                              <span className="text-danger">
                                {t("uniform_survey.choose_uniform.no_receive")}
                              </span>
                            </>
                          ) : (
                            <></>
                          )}
                          {uniformLastest?.slipperSize ===
                          "Bigger than normal size" ? (
                            <>{t("uniform_survey.choose_uniform.big_size")}</>
                          ) : (
                            <></>
                          )}
                          {uniformLastest?.slipperSize !==
                            "Bigger than normal size" &&
                          uniformLastest?.slipperSize !== "Decline" ? (
                            <>
                              {" "}
                              {t("uniform_survey.choose_uniform.size")}:{" "}
                              {uniformLastest?.slipperSize}{" "}
                              {t("uniform_survey.choose_uniform.UnitSlipper")}
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div>
                          {uniformLastest?.slipperSize ==
                          "Bigger than normal size" ? (
                            <p
                              className="text-danger"
                              style={{ fontSize: "10px" }}
                            >
                              {uniformLastest?.slipperSizeDescription}
                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                      </Col>
                      <Col xs={3} md={3} lg={2}>
                        <div className="number mt-4">
                          {uniformLastest?.slipperSize !== "Decline"
                            ? uniformLastest?.slipperQty
                            : 0}
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                  {uniformLastest && uniformLastest?.tumblerQty !== null ? (
                    <Row className="mb-1 align-items-center">
                      <Col xs={2} md={2} lg={2} className="text-center">
                        <img
                          src="../images/uniform/tumbler.png?a1"
                          alt="UniformSurvey"
                          width={45}
                          className="m-2 rounded item-shadow border"
                        />
                      </Col>
                      <Col xs={7} md={7} lg={8}>
                        <div className="list-title font-wiegth-bold">
                          {localStorage.getItem("Language") === "en"
                            ? uniformtype?.tumblerDescriptionEn
                            : uniformtype?.tumblerDescriptionTh}
                        </div>
                        <div className="list-size">
                          {/* {uniformLastest?.tumblerType !== 'Decline' ? (
                            t('uniform_survey.choose_uniform.receive')
                          ) : (
                            <>
                              <span className="text-danger">
                                {t('uniform_survey.choose_uniform.no_receive')}
                              </span>
                            </>
                          )} */}

                          {uniformLastest?.tumblerType !== "Decline" ? (
                            t("uniform_survey.choose_uniform.receive")
                          ) : (
                            <>
                              <span className="text-danger">
                                {t("uniform_survey.choose_uniform.no_receive")}
                              </span>
                            </>
                          )}
                          {uniformLastest?.tumblerType ===
                          "Bigger than normal size" ? (
                            <>{t("uniform_survey.choose_uniform.big_size")}</>
                          ) : (
                            <></>
                          )}
                        </div>
                      </Col>
                      <Col xs={3} md={3} lg={2}>
                        <div className="number mt-4">
                          <div className="number mt-4">
                            {uniformLastest?.tumblerType !== "Decline"
                              ? uniformLastest?.tumblerQty
                              : 0}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}
              {/* Home Button */}
              <Row className="mt-4 mb-3">
                <Col className="text-center">
                  <Button
                    variant="outline-primary"
                    onClick={() => navigate("/")}
                    className="d-flex align-items-center justify-content-center mx-auto"
                    style={{ width: "120px", borderRadius: "25px" }}
                  >
                    <span style={{ fontSize: "20px", marginRight: "8px" }}>
                      🏠
                    </span>
                    {t("uniform_survey.button.home") || "Home"}
                  </Button>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row style={{ height: "50px" }}>
                <Col
                  className="text-center w-100 d-flex align-items-center justify-content-center"
                  lg={12}
                >
                  <div className="uniform-load">
                    <div className="uniform-load loader"></div>
                  </div>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
    </>
  );
};
